import classNames from "classnames";
import classes from "./SlicedImage.module.less";

interface Props {
  className?: string;
  src: string;

  sliceSize?: number;
  gapSize?: number;
}

export const SlicedImage = ({ className, sliceSize = 1, gapSize = 1, src }: Props) => {
  return (
    <div
      className={classNames(classes.root, className)}
      style={
        {
          "--slice-size": `${sliceSize}px`,
          "--gap-size": `${gapSize}px`,
        } as any
      }
    >
      <img className={classes.image} src={src} />
    </div>
  );
};
